import React, { Component } from "react"
import { Button, Modal, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap"
import paramBoiler from "./ParamBoiler"
import Select from "react-select"
import { AppState } from "src/store"
import { connect } from "react-redux"
import ReferenceTypes from "src/store/UserReference/types"
import "./EmployeeKeyFilter.css"
import { shouldAllowAccess } from "src/utilities/helper"

interface EmployeeKeyFilterProps {
    search: Function
    toggleActive: Function
    closeDetailPanel: Function
    results: number
    userReference: ReferenceTypes
}

type EmployeeKeyFilterTypes = {
    menuOpen: boolean
    searchObject: any
    fakeLoading: boolean
}

class EmployeeKeyFilter extends Component<EmployeeKeyFilterProps, EmployeeKeyFilterTypes> {

    supervisorSelectRef: any = null;
    PTOPlanIdRef: any = null
    JobTitleRef: any = null
    HomeProfitCenterRef: any = null

    state = {
        menuOpen: false,
        searchObject: paramBoiler,
        fakeLoading: false,
    }

    componentDidMount() {
        const keys = Object.keys(paramBoiler)
        for (const key of keys) {
            paramBoiler[key] = []
        }
        this.setState({ searchObject: paramBoiler })
    }

    componentWillUnmount() {
        const keys = Object.keys(paramBoiler)
        for (const key of keys) {
            paramBoiler[key] = []
        }
    }

    selectStyles: any = {
        valueContainer: (provided: any, state: any): any => ({ ...provided, height: 35, overflow: "auto" })
    }

    toggleMenu = () => {
        if (this.state.menuOpen) {
            this.setState({ menuOpen: false })
            // this.clearAll()
        } else {
            this.setState({ menuOpen: true })
            this.props.closeDetailPanel()
        }
    }

    appendParams = (param: { key: string, triggers: Array<any> }) => {
        paramBoiler[param.key] = param.triggers
        this.setState({ searchObject: paramBoiler })
        this.search()
    }

    search = () => {
        const self = this
        this.setState({ fakeLoading: true })
        setTimeout(() => {
            self.setState({ fakeLoading: false })
            let params = Object.entries(paramBoiler)
            let temp: Array<{ key: string, triggers: Array<any> }> = []
            for (let i = 0; i < params.length; i++) {
                //@ts-ignore
                if (params[i][1].length > 0) {
                    //@ts-ignore
                    temp.push({ key: params[i][0], triggers: params[i][1] })
                }
            }
            self.props.search(temp, true)
        }, 500)
    }

    handleMissingPtoClick = (param: { key: string, triggers: Array<any> }) => {
        if (param.triggers.includes(null, 0)) {
            this.clearDropdown(this.PTOPlanIdRef, { key: "PTOPlanId", triggers: [] })
        }
        this.appendParams(param)
    }

    clearAll = () => {
        let keys = Object.keys(paramBoiler)
        for (let i = 0; i < keys.length; i++) {
            paramBoiler[keys[i]] = []
        }
        this.setState({ searchObject: paramBoiler })
        this.clearDropdown(this.PTOPlanIdRef, { key: "PTOPlanId", triggers: [] })
        this.clearDropdown(this.supervisorSelectRef, { key: "SupervisorID", triggers: [] })
        this.clearDropdown(this.JobTitleRef, { key: "JobTitle", triggers: [] })
        this.clearDropdown(this.HomeProfitCenterRef, { key: "HomeProfitCenterId", triggers: [] })
        this.props.search([])
    }

    clearDropdown = (ref: any, param: { key: string, triggers: Array<any> }) => {
        ref.select.clearValue()
        this.appendParams(param)
    }

    countOptions = () => {
        let obj: any = Object.values(this.state.searchObject)
        let options = 0
        for (let i = 0; i < obj.length; i++) {
            if (obj[i].length > 0) {
                options++
            }
        }
        return options
    }

    getSelectValues = (paramKey: string, referenceKey: string) => {
        let values: Array<{ id: number, text: string }> = []
        //@ts-ignore
        let reference: any = this.props.userReference[referenceKey]
        if (paramBoiler[paramKey].length > 0 && this.props.userReference) {
            for (let i = 0; i < reference.length; i++) {
                for (let j = 0; j < paramBoiler[paramKey].length; j++) {
                    if ((paramBoiler[paramKey][j] === reference[i].id) || (paramBoiler[paramKey][j] === reference[i].text)) {
                        values.push(reference[i])
                    }
                }
            }
            return values
        }
        return []
    }

    render() {

        const searchObject = paramBoiler
        const options = this.countOptions()
        const fakeLoading = this.state.fakeLoading
        // //console.log("searchObject", searchObject)
        // //console.log("paramBoiler", paramBoiler)

        const employeeKeyFilterTooltip = (text: string) => (
            <Tooltip id="employees-pin-tooltip">
                {text}
            </Tooltip>
        )

        return (
            <div className="EmployeeKeyFilter">

                {this.props.userReference && <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={employeeKeyFilterTooltip("Apply Filters")}>
                    <div className="OpenEmployeeKeyFilter" id="open-employee-search-options" onClick={() => this.toggleMenu()}>
                        <span className="material-icons">filter_alt</span>
                        {options > 0 && <p>Applied Filters ({options})</p>}
                    </div>
                </OverlayTrigger>}

                {!this.props.userReference && <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={employeeKeyFilterTooltip("Loading reference data...")}>
                    <Spinner id="open-employee-search-loading-reference" animation="border" />
                </OverlayTrigger>}

                {this.state.menuOpen && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="EmployeeKeyFilterModalHeader">
                            <span className="material-icons">filter_list</span>
                            {options === 0 && <p>Apply Filters</p>}
                            {options > 0 && <p id="employee-key-filter-modal-header-filters-applied">Applied Filters (<span>{options}</span>)</p>}
                            {!fakeLoading && options > 0 && <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={employeeKeyFilterTooltip("Clear Filters")}>
                                <span id="employee-search-options-modal-footer-clear-btn" className="material-icons" onClick={() => this.clearAll()}>clear_all</span>
                            </OverlayTrigger>}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {this.props.userReference && <div className="EmployeeKeyFilterModalBody">
                            <div className="EmployeeKeyFilterModalBodyR1">
                                {this.props.userReference.ptoPlans && <div className="EmployeeKeyFilterModalBodyR1Column">
                                    <div className="EmployeeKeyFilterModalBodyR1ColumnDropdownWrapper">
                                        <Select
                                            ref={(ref: any) => { this.PTOPlanIdRef = ref }}
                                            placeholder={"PTO Plan"}
                                            isMulti={true}
                                            styles={this.selectStyles}
                                            value={this.getSelectValues("PTOPlanId", "ptoPlans").map((item: any) => ({ value: item.id, label: item.text }))}
                                            options={this.props.userReference.ptoPlans.map((item: any) => ({ value: item.id, label: item.text }))}
                                            onChange={(item: any) => {
                                                if (item) {
                                                    let triggers = []
                                                    for (let i = 0; i < item.length; i++) {
                                                        triggers.push(item[i].value)
                                                    }
                                                    this.appendParams({ key: "PTOPlanId", triggers: triggers })
                                                } else {
                                                    this.appendParams({ key: "PTOPlanId", triggers: [] })
                                                }
                                            }}
                                            maxMenuHeight={400}
                                        />
                                    </div>
                                    {searchObject.PTOPlanId.length > 0 && JSON.stringify(searchObject.PTOPlanId) !== JSON.stringify([null, 0, -1]) && <div className="EmployeeKeyFilterModalBodyR1ColumnClearField">
                                        <span className="material-icons" onClick={() => this.clearDropdown(this.PTOPlanIdRef, { key: "PTOPlanId", triggers: [] })}>close</span>
                                    </div>}
                                    {/*why do I have to do this....dumb*/}
                                    {searchObject.PTOPlanId.length === 0 && <div className="EmployeeKeyFilterModalBodyR1ColumnCantClearField">
                                        <span className="material-icons">close</span>
                                    </div>}
                                    {searchObject.PTOPlanId.includes(-1) && <div className="EmployeeKeyFilterModalBodyR1ColumnCantClearField">
                                        <span className="material-icons">close</span>
                                    </div>}
                                </div>}
                                <div className="EmployeeKeyFilterModalBodyR1Column">
                                    <div className="EmployeeKeyFilterModalBodyR1ColumnDropdownWrapper">
                                        <Select
                                            ref={(ref: any) => { this.supervisorSelectRef = ref }}
                                            placeholder={"Supervisor"}
                                            isMulti={true}
                                            styles={this.selectStyles}
                                            value={this.getSelectValues("SupervisorID", "supervisors").map((item: any) => ({ value: item.id, label: item.text }))}
                                            options={this.props.userReference.supervisors.map((item: any) => ({ value: item.id, label: item.text }))}
                                            onChange={(item: any) => {
                                                if (item) {
                                                    let triggers = []
                                                    for (let i = 0; i < item.length; i++) {
                                                        triggers.push(item[i].value)
                                                    }
                                                    this.appendParams({ key: "SupervisorID", triggers: triggers })
                                                } else {
                                                    this.appendParams({ key: "SupervisorID", triggers: [] })
                                                }
                                            }}
                                            maxMenuHeight={400}
                                        />
                                    </div>
                                    {searchObject.SupervisorID.length > 0 && <div className="EmployeeKeyFilterModalBodyR1ColumnClearField">
                                        <span className="material-icons" onClick={() => this.clearDropdown(this.supervisorSelectRef, { key: "SupervisorID", triggers: [] })}>close</span>
                                    </div>}
                                    {searchObject.SupervisorID.length === 0 && <div className="EmployeeKeyFilterModalBodyR1ColumnCantClearField">
                                        <span className="material-icons">close</span>
                                    </div>}
                                </div>
                            </div>
                            <div className="EmployeeKeyFilterModalBodyR2">
                                <div className="EmployeeKeyFilterModalBodyR2">
                                    <div className="EmployeeKeyFilterModalBodyR2Column" id="employee-search-options-r2-c1">
                                        <div className="EmployeeKeyFilterModalBodyR2ColumnDropdownWrapper">
                                            <Select
                                                ref={(ref: any) => { this.JobTitleRef = ref }}
                                                placeholder={"Job Title"}
                                                isMulti={true}
                                                styles={this.selectStyles}
                                                value={this.getSelectValues("JobTitle", "jobTitles").map((item: any) => ({ value: item.id, label: item.text }))}
                                                options={this.props.userReference.jobTitles.map((item: any) => ({ value: item.id, label: item.text }))}
                                                onChange={(item: any) => {
                                                    if (item) {
                                                        let triggers = []
                                                        for (let i = 0; i < item.length; i++) {
                                                            triggers.push(item[i].label)
                                                        }
                                                        this.appendParams({ key: "JobTitle", triggers: triggers })
                                                    } else {
                                                        this.appendParams({ key: "JobTitle", triggers: [] })
                                                    }

                                                }}
                                                maxMenuHeight={400}
                                            />
                                        </div>
                                        {searchObject.JobTitle.length > 0 && JSON.stringify(searchObject.JobTitle) !== JSON.stringify([null, 0, -1]) && <div className="EmployeeKeyFilterModalBodyR2ColumnClearField">
                                            <span className="material-icons" onClick={() => this.clearDropdown(this.JobTitleRef, { key: "JobTitle", triggers: [] })}>close</span>
                                        </div>}
                                        {searchObject.JobTitle.length === 0 && <div className="EmployeeKeyFilterModalBodyR2ColumnCantClearField">
                                            <span className="material-icons">close</span>
                                        </div>}
                                    </div>
                                    <div className="EmployeeKeyFilterModalBodyR2Column" id="employee-search-options-r2-c1">
                                        <div className="EmployeeKeyFilterModalBodyR2ColumnDropdownWrapper">
                                            <Select
                                                ref={(ref: any) => { this.HomeProfitCenterRef = ref }}
                                                placeholder={"Home Profit Center"}
                                                isMulti={true}
                                                styles={this.selectStyles}
                                                value={this.getSelectValues("HomeProfitCenterId", "profitCenters").map((item: any) => ({ value: item.id, label: item.text }))}
                                                options={this.props.userReference.profitCenters.map((item: any) => ({ value: item.id, label: item.text }))}
                                                onChange={(item: any) => {
                                                    if (item) {
                                                        let triggers = []
                                                        for (let i = 0; i < item.length; i++) {
                                                            triggers.push(item[i].value)
                                                        }
                                                        this.appendParams({ key: "HomeProfitCenterId", triggers: triggers })
                                                    } else {
                                                        this.appendParams({ key: "HomeProfitCenterId", triggers: [] })
                                                    }
                                                }}
                                                maxMenuHeight={400}
                                            />
                                        </div>
                                        {searchObject.HomeProfitCenterId.length > 0 && JSON.stringify(searchObject.HomeProfitCenterId) !== JSON.stringify([null, 0, -1]) && <div className="EmployeeKeyFilterModalBodyR2ColumnClearField">
                                            <span className="material-icons" onClick={() => this.clearDropdown(this.HomeProfitCenterRef, { key: "HomeProfitCenterId", triggers: [] })}>close</span>
                                        </div>}
                                        {searchObject.HomeProfitCenterId.length === 0 && <div className="EmployeeKeyFilterModalBodyR2ColumnCantClearField">
                                            <span className="material-icons">close</span>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                            <div className="EmployeeKeyFilterModalBodyR3">
                                <div className="EmployeeKeyFilterModalBodyR3Column" id="employee-search-options-radio-btn">
                                    {searchObject.PTOPlanId.includes(null, 0, -1) && <div className="EmployeeKeyFilterModalBodyCustomRadio" onClick={() => this.handleMissingPtoClick({ key: "PTOPlanId", triggers: [] })}>
                                        <div className="EmployeeKeyFilterModalBodyCustomRadioChecked">
                                        </div>
                                        <p>Missing PTO Plan</p>
                                    </div>}
                                    {!searchObject.PTOPlanId.includes(null, 0, -1) && <div className="EmployeeKeyFilterModalBodyCustomRadio" onClick={() => this.handleMissingPtoClick({ key: "PTOPlanId", triggers: [null, 0, -1] })}>
                                        <div className="EmployeeKeyFilterModalBodyCustomRadioUnchecked">
                                        </div>
                                        <p>Missing PTO Plan</p>
                                    </div>}
                                </div>
                                {(shouldAllowAccess("HR:WORK-COMP-WRITER") || shouldAllowAccess("PORTAL:WORK-COMP-VIEWER")) && <div className="EmployeeKeyFilterModalBodyR3Column" id="employee-search-options-has-incident-btn">
                                    {searchObject.HasIncident.includes(1) && <div className="EmployeeKeyFilterModalBodyCustomRadio" onClick={() => this.appendParams({ key: "HasIncident", triggers: [] })}>
                                        <div className="EmployeeKeyFilterModalBodyCustomRadioChecked">
                                        </div>
                                        <p>Has Incident</p>
                                    </div>}
                                    {!searchObject.HasIncident.includes(1) && <div className="EmployeeKeyFilterModalBodyCustomRadio" onClick={() => this.appendParams({ key: "HasIncident", triggers: [1] })}>
                                        <div className="EmployeeKeyFilterModalBodyCustomRadioUnchecked">
                                        </div>
                                        <p>Has Incident</p>
                                    </div>}
                                </div>}
                                {(shouldAllowAccess("HR:WORK-COMP-WRITER") || shouldAllowAccess("PORTAL:WORK-COMP-VIEWER")) && <div className="EmployeeKeyFilterModalBodyR3Column" id="employee-search-options-has-open-btn">
                                    {searchObject.HasOpenIncident.includes(1) && <div className="EmployeeKeyFilterModalBodyCustomRadio" onClick={() => this.appendParams({ key: "HasOpenIncident", triggers: [] })}>
                                        <div className="EmployeeKeyFilterModalBodyCustomRadioChecked">
                                        </div>
                                        <p>Has Open Incident</p>
                                    </div>}
                                    {!searchObject.HasOpenIncident.includes(1) && <div className="EmployeeKeyFilterModalBodyCustomRadio" onClick={() => this.appendParams({ key: "HasOpenIncident", triggers: [1] })}>
                                        <div className="EmployeeKeyFilterModalBodyCustomRadioUnchecked">
                                        </div>
                                        <p>Has Open Incident</p>
                                    </div>}
                                </div>}
                            </div>
                        </div>}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="EmployeeKeyFilterModalFooter">
                            {!fakeLoading && <Button id="employee-search-options-modal-footer-toggle-btn" variant="secondary" onClick={() => this.toggleMenu()}>Back</Button>}
                            {!fakeLoading && options > 0 && <p id="employee-search-options-modal-footer-results">Found <span>{this.props.results}</span> results</p>}
                            {fakeLoading && <Spinner id="employee-search-options-modal-footer-spinner" animation="border" />}
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userReference: state.userReference.userReference
})

export default connect(mapStateToProps)(EmployeeKeyFilter)